/**
 * Lithuanian money and number formatting.
 *
 * Decimal comma, EUR. Formatting lives on the client only for the live preview;
 * anything WooCommerce renders goes through wc_price() so the cart and the
 * configurator cannot drift apart in presentation.
 */

/** Formats integer cents as a Lithuanian EUR amount. */
export function money(cents: number): string {
	const sign = cents < 0 ? '−' : '';
	const abs = Math.abs(cents);
	const whole = Math.floor(abs / 100);
	const frac = String(abs % 100).padStart(2, '0');

	return `${sign}${whole.toLocaleString('lt-LT')},${frac} €`;
}

/**
 * The price pair the owner asked for: inclusive primary, exclusive alongside.
 *
 * DECISIONS D14. The inclusive figure is what the customer pays and is exact; the
 * exclusive one is derived from it for the B2B reader.
 */
export function pricePair(inclCents: number, exclCents: number, vatSuffix: string): string {
	return `${money(inclCents)} (${vatSuffix} ${money(exclCents)})`;
}
